export class LineStyle {
  constructor(
    public color?: string,
    public width?: number,
    public opacity?: number,
    public lineType?: number[],
  ) {}
}
